// ©2024 Austin App House. All rights reserved.
import 'react-datepicker/dist/react-datepicker.css';
import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import { ResourceDataTable } from '../../components/datatables/ResourceDataTable';
import { datatableManagerFundsColumnsForSuperAdmin as columns } from '../../utils/constans';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';

const ManageFunds = ({
  toggleModal, mainContainer, isReload,
}) => (
  <div className="subpage-wrap subpage-wrap--admin">
    <div className="subpage-header">
      <h1 className="subpage-title">Transaction History</h1>
      <div className="subpage-toolbar">
        <button
          type="button"
          className="subpage-btn subpage-btn--ghost"
          onClick={() => toggleModal(true, 'admminFilters')}
        >
          <DashboardIcon name="filter" size={18} strokeWidth="2.5" />
          Filters
        </button>
      </div>
    </div>
    <div className="subpage-table-scroll">
      <ResourceDataTable
        entity="/api/payment/history"
        columns={columns}
        isReload={isReload}
        toggleModal={toggleModal}
        className="subpage-datatable"
      />
    </div>
  </div>
);

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = state => ({
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageFunds);
